$(function () {
    if ($('form#UserEditForm').length > 0) {


        $(".btnSend").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($("form").valid()) {
                $("#approveModal").modal({
                    'backdrop': 'static'
                });
            }

            return false;
        });

        $(".btnSave").on('click', function (e) {
            if (jsCanChangePrimary) {
                var wasPrimary = $("#WasOriginallyPrimary").val() == "True";
                var isPrimary = $(".make-primary-chk").is(":checked");
                if (wasPrimary != isPrimary) {
                    e.stopPropagation();
                    e.preventDefault();

                    if ($("form").valid()) {
                        $("#primaryModal").modal({
                            'backdrop': 'static'
                        });
                    }

                    return false;
                }
                else {
                    if ($("form").valid()) {
                        $("#approveChangesModal").modal({
                            'backdrop': 'static'
                        });
                    }
                }
            }
        });

        $(".btnContinue").on('click', function () {
            $("form").submit();
        });

        HandleRoleSelectionOnload(null);
        $(".lblStopPropagation").on('click touchstart', function (e) { // click or touch on label
            e.stopPropagation();
        });


        $(".owner-operator-chk").change(function () {
            if ($(this).is(':checked')) {
                $(".make-primary-chk").prop('disabled', false);
                $("#accordion").find(":checkbox").each(function () {
                    if (!$(this).hasClass('owner-operator-chk') && !$(this).hasClass('make-primary-chk')) {
                        $(this).prop('disabled', true);
                        $(this).prop('checked', false);
                    }
                });
            } else {
                $(".make-primary-chk").prop('checked', false);
                $(".make-primary-chk").prop('disabled', true);
                $(".make-primary-chk").change();
                $("#accordion").find(":checkbox").each(function () {
                    if (!$(this).hasClass('owner-operator-chk') && !$(this).hasClass('make-primary-chk')) {
                        $(this).prop('disabled', false);
                    }
                });
            }
        });
        $(".owner-operator-chk").change();

        if (jsIsPrimaryOperator) {
            $(".make-primary-chk").prop('checked', true);
        }

        $(".make-primary-chk").change(function () {
            if ($(this).is(":checked")) {
                $("#IsPrimaryOperator").val(true);
            } else {
                $("#IsPrimaryOperator").val(false);
            }
        });

        if (jsCanChangePrimary) {
            $(".operator-admin-div").removeClass("d-none");
        }

        $(".licensecheckbox").on('click touchstart', function () {
            var self = $(this);

            HandleRoleSelectionOnClicks(self);
        });

        function HandleRoleSelectionOnload() {

            $(".EnrolCss").each(function () {


                var EnrolCheckBox = $(this);
                console.log(EnrolCheckBox.attr('id'));

                var parent = EnrolCheckBox.closest(".role-card");                

                if (!parent || parent.length == 0) {
                    parent = EnrolCheckBox;
                }

                //number of checked checkboxes
                var noChecked = parent.find('.licence-card .custom-control-input:checked').length;
                //number of all checkboxes
                var noCheckBoxes = parent.find('.licence-card .custom-control-input').length;

                //check all option is one of loaded selected options
                if (parent.find(".chk-0").length > 0 && parent.find(".chk-0").is(":checked")) {
                    var chkdStatus = true;
                    EnrolCheckBox.prop('indeterminate', false);
                    EnrolCheckBox.prop('checked', chkdStatus);
                    parent.find('.licensecheckbox').prop('checked', chkdStatus);
                }
                else if (parent.find(".chk-0").length > 0 && !parent.find(".chk-0").is(":checked") && (noChecked == (noCheckBoxes - 1))) {
                    var chkdStatus = true;
                    EnrolCheckBox.prop('indeterminate', false);
                    EnrolCheckBox.prop('checked', chkdStatus);
                    parent.find('.licensecheckbox').prop('checked', chkdStatus);
                }
                else {
                    var me = 0;
                    if (noChecked == 0) {
                        //all are not checked without using all option
                        EnrolCheckBox.prop('indeterminate', false);
                        EnrolCheckBox.prop('checked', false);
                        console.log(1);

                    }
                    else if (noChecked > 0 && noChecked == noCheckBoxes - me) {
                        //all are checked without using all option
                        EnrolCheckBox.prop('indeterminate', false);
                        EnrolCheckBox.prop('checked', true);

                        parent.find(".chk-0").prop('checked', true);
                        console.log(2);
                        
                    }
                    else if (parent.find(".chk-0").length == 0 && noChecked == 1 && noChecked == 1) {
                        //only one item so all option doen't exist
                        EnrolCheckBox.prop('indeterminate', false);
                        EnrolCheckBox.prop('checked', true);
                        console.log(3);

                    }
                    else if (noChecked > 0 && noChecked != noCheckBoxes - me) {
                        //one or more licence checked but bnot all of them-for sure without using all option
                        var chkdStatus = false;
                        parent.find(".chk-0").prop('checked', false);
                        EnrolCheckBox.prop('indeterminate', true);
                        console.log(4);
                    }
                }
            });

        };

        function HandleRoleSelectionOnClicks(self) {

            // TODO: limit changes to current role

            console.log(self); 

            var parent = self.closest(".role-card");
            var EnrolCheckBox = parent.find('.EnrolCss');

            //number of checked checkboxes
            var noChecked = parent.find('.licence-card .custom-control-input:checked').length;
            console.log('noChecked = ' + noChecked); 

            //number of all checkboxes
            var noCheckBoxes = parent.find('.licence-card .custom-control-input').length;
            console.log('noCheckBoxes = ' + noCheckBoxes); 

            //if (self.siblings(".custom-control-inputvalue").val() == "0") {
            //if (parent.find(".chk-0").length > 0 && parent.find(".chk-0").is(":checked")) {
            if (self.hasClass("chk-0")) {
                var chkdStatus = self.is(":checked");
                EnrolCheckBox.prop('indeterminate', false);
                EnrolCheckBox.prop('checked', chkdStatus);
                parent.find('.licensecheckbox').prop('checked', chkdStatus);
                console.log(0);
            }
            else
            {

                var me = 0;
                if (self.is(":checked")) {
                    me = 1;
                }

                console.log('me = ' + me);

                if (noChecked == 0) {
                    //all are not checked without using all option
                    EnrolCheckBox.prop('indeterminate', false);
                    EnrolCheckBox.prop('checked', false);
                    console.log(1);

                }
                else if (noChecked > 0 && noChecked == noCheckBoxes - me) {
                    //all are checked without using all option
                    EnrolCheckBox.prop('indeterminate', false);
                    EnrolCheckBox.prop('checked', true);

                    parent.find(".chk-0").prop('checked', true);
                    console.log(2);

                }
                else if (parent.find(".chk-0").length == 0 && noChecked == 1 && noChecked == 1) {
                    //only one item so  all option doesn't exist
                    EnrolCheckBox.prop('indeterminate', false);
                    EnrolCheckBox.prop('checked', true);
                    console.log(3);

                }
                else if (noChecked > 0 && noChecked != noCheckBoxes - me) {
                    //one or more licence checked but bnot all of them-for sure without using all option
                    var chkdStatus = false;
                    parent.find(".chk-0").prop('checked', false);
                    EnrolCheckBox.prop('indeterminate', true);
                    console.log(4);

                }

            }

        }

    } // if ($('form#UserEditForm').length > 0)
}); // $(function () {